import {
  Api,
  ApiUrl
} from "../../services";
import {
  mutations as MUTATION,
  actions as ACTION
} from "./types";


let transformPageType = originalType => {
  switch (originalType) {
    case "subpages":
      return "template-page";
    case "articlepages":
      return "template-article";
    case "homepages":
      return "template-index";
    case "productpages":
      return "template-product";
    case "collectionpages":
      return "template-collection";
    default:
      return "";
  }
};

const actions = {
  [ACTION.GROUP_FETCH_LIST]: async (store, { pageType, onSuccess, onError }) => {
    const { state } = store;
    try {
      if (!state[pageType].fetched) {
        const res = await Api.base.get(ApiUrl.base.group.list, {
          params: {
            pageType: transformPageType(pageType)
          }
        });
        if (res && res.data && res.data.groups) {
          store.commit(MUTATION.GROUP_FETCH_LIST, {
            groups: res.data.groups,
            pageType: pageType
          });
        }
      }
      state[pageType].fetched = true;
      if (onSuccess) onSuccess()
    } catch (error) {
      state[pageType].fetched = true;
      if (onError) onError(error)
    }
  },
  [ACTION.GROUP_GET_PAGES]: async (store, { group_id, onSuccess, onError }) => {
    try {
      const res = await Api.base.get(ApiUrl.base.group.get);
      if (res && res.data && res.data.pages) {
        store.commit(MUTATION.GROUP_ADD_PAGES(group_id, res.data.pages))
      }

      if (onSuccess) onSuccess()
    } catch (error) {
      if (onError) onError(error)
    }
  },
  [ACTION.GROUP_CREATE]: (store, { name, pageType, pageId }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let pType = transformPageType(pageType);

        let data = {
          name: name,
          pageType: pType,
          pageId: pageId
        }
        let res = await Api.base.post(ApiUrl.base.group.create, data);

        if (res.data.status == "error") {
          throw res.data.message;
        }
        resolve(res);

        let newGroup = res.data.group;
        if (pageId) {
          newGroup.count = 1;
        } else {
          newGroup.count = 0;
        }

        store.commit(MUTATION.GROUP_FETCH_LIST, {
          groups: [newGroup],
          pageType: pageType
        });
      } catch (error) {
        reject(error)
      }
    })
  },
  [ACTION.GROUP_UPDATE]: (store, { pageType, groupUpdated }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          name: groupUpdated.name
        }

        let res = await Api.base.put(ApiUrl.base.group.update(groupUpdated.id), data);

        if (res.data.status == "error") {
          throw res.data.message;
        }

        resolve(res)

        store.commit(MUTATION.GROUP_UPDATE, { groupUpdated, pageType });
      } catch (error) {
        reject(error)
      }
    })
  },
  [ACTION.GROUP_DELETE]: (store, { pageType, groupId, removePages = false }) => {
    return new Promise(async (resolve, reject) => {
      try {
        let data = {
          removePages: removePages
        }

        let res = await Api.base.delete(ApiUrl.base.group.delete(groupId), data);

        if (res.data.status == "error") {
          throw res.data.message;
        }

        resolve(res)

        store.commit(MUTATION.GROUP_DELETE, { group_id: groupId, pageType });
      } catch (error) {
        reject(error)
      }
    })
  }
};

export default actions;
